module.exports = __webpack_public_path__ + "img/flow-md.c21d0c50.svg";